import {areProductScreensAvailable, initializeProductSlider} from "layouts/_product_screens";
import "./creator.scss";

document.addEventListener("DOMContentLoaded", () => {
  if (areProductScreensAvailable()) {
    initializeProductSlider();
  }
});
